
























































import { Component, Prop, Vue, Inject, Ref } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ServizioPeriodicoPeriod from './ServizioPeriodicoPeriod.vue';
import ServizioPeriodicoDatiServizio from './ServizioPeriodicoDatiServizio.vue';
import ServizioPeriodicoNote from './ServizioPeriodicoNote.vue';
import ServizioPeriodicoServiziTable from './ServizioPeriodicoServiziTable.vue';
import { CrudService } from '@/data/services/crud.service';
import { PeriodicService } from '@/data/models/periodicservice.model';
import store, { State } from '@/store';
import { PeriodicItem } from '@/data/models/periodicitem.model';
import { PeriodicEntityService } from '@/data/services/periodic.service';
import { clone, cloneDeep } from 'lodash';
import { dateEndofDay, mergeDates } from '@/data/utils/helper';

@Component({
	components: {
		ServizioPeriodicoPeriod,
		ServizioPeriodicoDatiServizio,
		ServizioPeriodicoNote,
		ServizioPeriodicoServiziTable,
		ValidationObserver,
		ValidationProvider,
	},
})
export default class ServizioPeriodicoDetail extends Vue {
	@Prop() servizioperiodicoid?: number | string;
	@Prop() cloneid?: number | string;
	@Prop({ default: true }) editable!: boolean;
	@Ref('period') period: any;

	@Inject('CrudService') crudService!: CrudService<PeriodicService>;
	@Inject('CrudService') itemcrudService!: CrudService<PeriodicItem>;
	@Inject('PeriodicEntityService') periodicentityService!: PeriodicEntityService;

	periodicservice!: PeriodicService;

	loading: boolean = false;
	hqid!: number | undefined;
	state!: State;

	constructor() {
		super();
		this.state = store;
		this.hqid = store.headquarter!.id;
		this.periodicservice = new PeriodicService();
	}

	loadServizioPeriodico(id: number) {
		this.loading = true;

		this.crudService
			.getEntity(PeriodicService, 'periodicservice', id)
			.then(result => {
				this.periodicservice = result;
				if (this.cloneid) this.periodicservice.id = undefined;
				this.period.init(this.periodicservice);
			})
			.catch(error => {
				this.$buefy.notification.open({
					message: error.msg,
					type: 'is-danger'
				});
			}).finally(() => this.loading = false);
	}

	created() {
		if (this.servizioperiodicoid) {
			this.loadServizioPeriodico(+this.servizioperiodicoid);
		} else if (this.cloneid) {
			this.loadServizioPeriodico(+this.cloneid);
		} else {
			this.periodicservice = new PeriodicService();
		}
	}

	submit() {
		this.periodicservice.hqid = store.headquarter!.id;
		if (this.periodicservice.patient) this.periodicservice.patientid = this.periodicservice.patient.id;
		if (this.periodicservice.driver) this.periodicservice.driverid = this.periodicservice.driver.id;
		if (this.periodicservice.vehicle) this.periodicservice.vehicleid = this.periodicservice.vehicle.id;
		//if (this.periodicservice.servicetypeid) this.periodicservice.servicetypeid = this.periodicservice.servicetype.id;
		if (this.periodicservice.seconddriver) this.periodicservice.seconddriverid = this.periodicservice.seconddriver.id;
		if (this.periodicservice.payer) this.periodicservice.payerid = this.periodicservice.payer.id;

		const pickupSelect: any = cloneDeep(this.periodicservice.pickup);
		const dropoffSelect: any = cloneDeep(this.periodicservice.dropoff);
		this.periodicservice.pickup = typeof pickupSelect === 'object' ? pickupSelect.name : pickupSelect;
		this.periodicservice.dropoff = typeof dropoffSelect === 'object' ? dropoffSelect.name : dropoffSelect;

		const keeproute = !!this.periodicservice.id;
		const pickup = this.periodicservice.pickup!;
		const dropoff = this.periodicservice.dropoff!;

		this.periodicservice.periodenddate = dateEndofDay(this.periodicservice.periodenddate!);

		this.crudService.createEntity(PeriodicService, 'periodicservice', this.periodicservice).then(result => {
			this.periodicservice = result;
			this.periodicservice.pickup = clone(pickup);
			this.periodicservice.dropoff = clone(dropoff);
			if (!keeproute) this.$router.push(`/servizi-periodici/${result.id}/edit`);
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	savePeriodicItems(items: PeriodicItem[]) {
		if (this.periodicservice.hasPeriodicItems) {
			this.saveSinglePeriodicItems(items);
		} else {
			this.saveBatchPeriodicItems(items);
		}
	}

	saveSinglePeriodicItems(items: PeriodicItem[]) {
		const requests: any[] = [];
		if (items.length) {
			for (const i of items) {
				i.serviceid = this.periodicservice.id;
				const request: any = i.id ?
					this.itemcrudService.saveEntity(PeriodicItem, 'periodicitem', i) :
					this.itemcrudService.createEntity(PeriodicItem, 'periodicitem', i);
				requests.push(request);
			}

			Promise.all(requests).then(() => {
				this.loadServizioPeriodico(this.periodicservice.id!);
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
			}).catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
		}
	}

	saveBatchPeriodicItems(items: PeriodicItem[]) {
		if (items.length) {
			for (const i of items) {
				i.serviceid = this.periodicservice.id;
			}
			this.periodicentityService.saveAllPeriodicItemForService(this.periodicservice!.id!, items)
				.then((results: PeriodicItem[]) => {
					this.periodicservice.periodicitems = results;
					this.period.init(this.periodicservice);
					this.$buefy.notification.open({
						message: this.$t('success-save') as string,
						type: 'is-success',
					});
				}).catch(({ data }) => {
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
				});
		}
	}

	onChangeDate() {
		// if you have a calendar already set, this ensure that periodic items start/end dates get updated in case we change serviceperiod start/end dates as the 4 dates are related, the helper doesn't manipulate time
		for (const key in this.period.calendarOneway) {
			if (this.period.calendarOneway[key]) {
				this.period.calendarOneway[key].startdate = mergeDates(
					this.periodicservice!.periodstartdate!,
					this.period.calendarOneway[key].startdate
				);
				this.period.calendarOneway[key].stopdate = mergeDates(
					this.periodicservice!.periodenddate!,
					this.period.calendarOneway[key].stopdate
				);
			}
		}
		for (const key in this.period.calendarRoundtrip) {
			if (this.period.calendarRoundtrip[key]) {
				this.period.calendarRoundtrip[key].startdate = mergeDates(
					this.periodicservice!.periodstartdate!,
					this.period.calendarRoundtrip[key].startdate
				);
				this.period.calendarRoundtrip[key].stopdate = mergeDates(
					this.periodicservice!.periodenddate!,
					this.period.calendarRoundtrip[key].stopdate
				);
			}
		}
	}
}
